// extracted by mini-css-extract-plugin
export var categoryTag = "FeaturedArticle-module--categoryTag--e1ad7";
export var image = "FeaturedArticle-module--image--2e33a";
export var section = "FeaturedArticle-module--section--83aa9";
export var text = "FeaturedArticle-module--text--07740";